import { inkBackgroundTokens, inkBorderTokens } from '@ds/tokens'

const tokens = {
  borderColor: inkBorderTokens.borderColorSubtle,
  defaultBackgroundColor: inkBackgroundTokens.bgColorDefault,
} as const

export default tokens
